import React from "react";
import FAQs from "../../components/AdminSideComponents/faq/FAQs";

const AuthFAQs = () => {
  return (
    <div>
      <FAQs />
    </div>
  );
};

export default AuthFAQs;
